import(/* webpackMode: "eager" */ "/root/ttc-market/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"preload\":false}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/ttc-market/frontend/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/root/ttc-market/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/root/ttc-market/frontend/src/app/providers.tsx");
